// Envoie une photo (déjà compressée, voir compressImage.js) au script Apps
// Script déployé, qui la dépose sur Google Drive et renvoie une URL.
// Remplace l'upload Firebase Storage pour rester sur le forfait gratuit.

const APPS_SCRIPT_URL = process.env.REACT_APP_APPS_SCRIPT_URL;

function blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error("Lecture du fichier compressé impossible"));
    reader.readAsDataURL(blob);
  });
}

/**
 * @param {Blob} blob - image compressée (sortie de compressImage.js)
 * @param {string} fileName - nom de fichier d'origine
 * @param {string} mimeType - type MIME (ex: "image/jpeg")
 * @returns {Promise<string>} URL Google Drive de la photo déposée
 */
export async function uploadPhotoToDrive(blob, fileName, mimeType) {
  if (!APPS_SCRIPT_URL) {
    throw new Error(
      "REACT_APP_APPS_SCRIPT_URL n'est pas configuré (voir .env.example)."
    );
  }

  const base64 = await blobToBase64(blob);
  let derniereErreur = null;

  // Jusqu'à 3 tentatives : un script Google qui se réveille ou un réseau
  // mobile instable peuvent faire échouer ponctuellement un envoi.
  for (let tentative = 1; tentative <= 3; tentative++) {
    try {
      // Content-Type "text/plain" volontaire : évite la requête de préflight
      // CORS (OPTIONS) que les Web Apps Apps Script ne gèrent pas nativement.
      const response = await fetch(APPS_SCRIPT_URL, {
        method: "POST",
        headers: { "Content-Type": "text/plain;charset=utf-8" },
        body: JSON.stringify({ base64, fileName, mimeType }),
      });
      const texte = await response.text();
      let result;
      try {
        result = JSON.parse(texte);
      } catch (e) {
        throw new Error("Réponse inattendue du script photos (HTTP " + response.status + ") : " + texte.slice(0, 120));
      }
      if (!result.success) throw new Error(result.error || "Échec de l'envoi de la photo");
      return result.url;
    } catch (err) {
      derniereErreur = err;
      if (tentative < 3) await new Promise((r) => setTimeout(r, 1200 * tentative));
    }
  }
  throw new Error("Photo « " + fileName + " » : " + (derniereErreur && derniereErreur.message ? derniereErreur.message : derniereErreur));
}

// "Réveille" le script Apps Script dès que l'utilisateur choisit une photo :
// le premier appel à un script endormi prend plusieurs secondes. Le corps
// envoyé n'est pas du JSON, donc le script répond aussitôt par une erreur
// sans rien créer sur le Drive ; seul le réveil compte.
let dejaPrechauffe = false;
export function prechaufferEnvoiPhotos() {
  if (dejaPrechauffe || !APPS_SCRIPT_URL) return;
  dejaPrechauffe = true;
  fetch(APPS_SCRIPT_URL, {
    method: "POST",
    headers: { "Content-Type": "text/plain;charset=utf-8" },
    body: "reveil",
  }).catch(() => {});
}
